/**
 * Review severity scoring utilities.
 * Shared between API and CLI for consistent severity handling.
 */

export const EXECUTION_REVIEW_SEVERITY_VALUES = [
  "low",
  "medium",
  "high",
] as const;
